// extracted by mini-css-extract-plugin
export var card = "DevKitOrders-module__card___wvjtk";
export var cardHeader = "DevKitOrders-module__cardHeader___hE5A2";
export var cardSubtitle = "DevKitOrders-module__cardSubtitle___MaCDN";
export var cardTitle = "DevKitOrders-module__cardTitle___3xjFa";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var large = "1084px";
export var studioDevKitsSectionContent = "DevKitOrders-module__studioDevKitsSectionContent___q7v8i";
export var studioDevKitsSectionTitle = "DevKitOrders-module__studioDevKitsSectionTitle___L-RQu";
export var welcomeParterPageDevsKitContainerRow = "DevKitOrders-module__welcomeParterPageDevsKitContainerRow___UzgTx";
export var welcomeParterPageDevsKitContentRow = "DevKitOrders-module__welcomeParterPageDevsKitContentRow___ZZ9uu";